/**
 * ui
 *
 * @author Shigq
 * @date 2021/11/22 15:34
 */
var netConfig = require('../../../ui/config/net.config')
var vab = require('../../../ui/utils/vab')

module.exports = {
	netConfig,
	vab
}
